import { Center } from "@chakra-ui/react";

export interface SelectbtnProps {
    borderWidth: string;
    borderColor: string;
    bgColor: string;
    color: string;
    callbackOnClick: () => void;
    label: string;
}

const SelectBtn = (props: SelectbtnProps) => {
    const { borderWidth, borderColor, bgColor, color, callbackOnClick, label } =
        props;

    return (
        <Center
            fontSize="14px"
            fontWeight={"medium"}
            w="9.65rem"
            h="2.875rem"
            borderWidth={borderWidth}
            borderRadius="md"
            borderColor={borderColor}
            bgColor={bgColor}
            color={color}
            onClick={callbackOnClick}
        >
            {label}
        </Center>
    );
};
export default SelectBtn;
